import { render } from "./MerchProdWhse.vue?vue&type=template&id=443cf712&scoped=true"
const script = {}

import "./MerchProdWhse.vue?vue&type=style&index=0&id=443cf712&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443cf712"]])

export default __exports__